export const INVALID_PROMOTION_CODE_ERROR = 'Invalid or expired promotion code';
